import React from 'react';

const FooterSkipLink = () => {
  if (typeof document !== 'undefined' && document.getElementById('footer-page')) {
    return (
      <a className="skip-link hmf-subheader-bold-m hmf-p-xxs hmf-m-xxs" href="/#footer-page">
        Skip to Footer
      </a>
    );
  }
  return null;
};

export default FooterSkipLink;
